import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CATEGORIES } from "../../../Json/categorias";
import Buscador from "../../Layout/Buscador/Buscador";
import "./homeCategorias.css";

const HomeCategorias = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    // Fuerza a 3 categorías
    const CATS = useMemo(() => (Array.isArray(CATEGORIES) ? CATEGORIES.slice(0, 3) : []), []);

    useEffect(() => {
        const data = localStorage.getItem("logindata");
        if (!data) return;
        try { setUser(JSON.parse(data)); } catch { setUser(null); }
    }, []);

    // Parallax + shine por tarjeta
    const handleMove = (e) => {
        const el = e.currentTarget;
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;   // 0..1
        const y = (e.clientY - rect.top) / rect.height;   // 0..1
        const rx = (0.5 - y) * 10; // rotación X
        const ry = (x - 0.5) * 12; // rotación Y
        el.style.setProperty("--rx", `${rx}deg`);
        el.style.setProperty("--ry", `${ry}deg`);
        el.style.setProperty("--mx", `${x * 100}%`);
        el.style.setProperty("--my", `${y * 100}%`);
    };

    const handleLeave = (e) => {
        const el = e.currentTarget;
        el.style.setProperty("--rx", `0deg`);
        el.style.setProperty("--ry", `0deg`);
        el.style.setProperty("--mx", `50%`);
        el.style.setProperty("--my", `50%`);
    };

    return (
        <section className="home-categorias container-mh">
            <div className="container-fluid py-3 py-md-4">
                <div className="row align-items-start g-3">
                    <div className="col-12">
                        <div className="home-intro">
                            {user ? (
                                <h2 className="home-h2">Bienvenido a BubUP, {user.data?.name || "usuario"} 👋</h2>
                            ) : (
                                <h2 className="home-h2">No has iniciado sesión</h2>
                            )}
                            <p className="muted">Explora las categorías disponibles.</p>
                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12">
                        <Buscador />
                    </div>
                </div>

                {/* Grid: 3/2/1 */}
                <div className="categorias-grid mt-4">
                    {CATS.map((cat, idx) => (
                        <article
                            key={cat.name || idx}
                            className="categoria-cardPro"
                            onMouseMove={handleMove}
                            onMouseLeave={handleLeave}
                            onClick={() => navigate(`/categoria/${encodeURIComponent(cat.name)}`)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    navigate(`/categoria/${encodeURIComponent(cat.name)}`);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label={`Abrir categoría ${cat.name}`}
                        >
                            {/* Gradient ring */}
                            <span aria-hidden className="ring" />

                            {/* Imagen + overlay + shine */}
                            <div className="media">
                                <img src={cat.image} alt={cat.name} loading="lazy" />
                                <div className="overlay" />
                                <div className="shine" />
                            </div>

                            {/* Contenido */}
                            <div className="content">
                                <h3 className="title">{cat.name}</h3>
                                <p className="desc">Descubre lo mejor de <strong>{cat.name}</strong> cerca de ti.</p>
                                <span className="cta">
                                    Explorar
                                    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeCategorias;